import http from "../../../Utils/http";

export const me = () => http.get("api/me");